import axios from 'axios';
import { displayFile, downloadFile } from '../utils/files';
import { TCallback, TCallbackVoid } from '../utils/interfaces/interfaces';
import { admin_legislationAPI, principal_legislationAPI } from './routes';

const getAllLegislationAdmin = (callback: TCallback) => {
  axios.get(admin_legislationAPI.ALL).then(({ data }) => callback(data.data));
};

const getOneLegislationAdmin = (id: number, callback: TCallback) => {
  axios.get(admin_legislationAPI.BY_ID(id)).then(({ data }) => callback(data));
};

const downloadOneLegislationAdmin = (id: number, name: string) => {
  axios
    .get(admin_legislationAPI.DOWNLOAD(id), { responseType: 'blob' })
    .then(({ data }) => {
      downloadFile(data, name);
    });
};

const displayOneLegislationAdmin = (id: number, name: string) => {
  axios
    .get(admin_legislationAPI.DOWNLOAD(id), { responseType: 'blob' })
    .then(({ data }) => {
      return displayFile(data, name);
    });
};
const addLegislationAdmin = (
  name: string,
  type: string,
  file: File,
  callback: TCallbackVoid
) => {
  const data = new FormData();
  data.append('name', name);
  data.append('type', type);
  data.append('file', file);
  axios.post(admin_legislationAPI.ALL, data).then(() => {
    callback();
  });
};

const deleteLegislationAdmin = (id: number, callback: TCallbackVoid) => {
  axios.delete(admin_legislationAPI.DELETE(id)).then(() => {
    callback();
  });
};

/* */
/* principal account */
const getAllLegislationPrincipal = (callback: TCallback) => {
  axios
    .get(principal_legislationAPI.ALL)
    .then(({ data }) => callback(data.data));
};

const deleteLegislationPrincipal = (id: number, callback: TCallbackVoid) => {
  axios.delete(principal_legislationAPI.DELETE(id)).then(() => {
    callback();
  });
};

const getOneLegislationPrincipal = (id: number, callback: TCallback) => {
  axios
    .get(principal_legislationAPI.BY_ID(id))
    .then(({ data }) => callback(data));
};

const downloadOneLegislationPrincipal = (id: number, name: string) => {
  axios
    .get(principal_legislationAPI.DOWNLOAD(id), { responseType: 'blob' })
    .then(({ data }) => {
      downloadFile(data, name);
    });
};

const displayOneLegislationPrincipal = async (id: number, name: string) => {
  const { data } = await axios.get(principal_legislationAPI.DOWNLOAD(id), {
    responseType: 'blob'
  });

  return displayFile(data, name);
};

const addLegislationPrincipal = (
  name: string,
  type: string,
  file: File,
  callback: TCallbackVoid
) => {
  const data = new FormData();
  data.append('name', name);
  data.append('type', type);
  data.append('file', file);
  axios.post(principal_legislationAPI.ALL, data).then(() => {
    callback();
  });
};

export {
  /* admin account */
  getAllLegislationAdmin,
  addLegislationAdmin,
  deleteLegislationAdmin,
  downloadOneLegislationAdmin,
  getOneLegislationAdmin,
  /* principal account */
  getAllLegislationPrincipal,
  deleteLegislationPrincipal,
  addLegislationPrincipal,
  downloadOneLegislationPrincipal,
  getOneLegislationPrincipal,
  /* display pdfs links */
  displayOneLegislationPrincipal,
  displayOneLegislationAdmin
};
